import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { PAGE_NAME_STEPS, FastLaneWizardService } from '../services/fastlane-wizard.service';
import { FastLaneWizardStep } from '../models/fastlane-wizard-state';

function getStepIndex(url: string) {
	for (const [i, PAGE_NAME_STEP] of PAGE_NAME_STEPS.entries()) {
		if (url.includes(PAGE_NAME_STEP)) {
			return i;
		}
	}
	return FastLaneWizardStep.MAINDATA;
}

export const wizardEnterGuard: CanActivateFn = async (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const appWizardService = inject(FastLaneWizardService);
	const stepIndex = getStepIndex(state.url);
	await appWizardService.checkWizardStateValidity(stepIndex);
	return true;
};
